import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { UserService } from '../../services/user/user.service';
import { SkinService } from 'src/app/system/utility/skin.service';
import { AppMode, AppModeService } from 'src/app/system/utility/app-mode.service';



@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    standalone: false
})
export class FooterComponent implements OnInit {

  protected SkinService: any = SkinService;
  protected AppMode = AppMode;

  loggedIn : BehaviorSubject<boolean>;
  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;

  disclaimerLogin!: string | null;
  externalLoaded: boolean = false;
  customerMenuStyle: string = 'top';
  copyrightMessage: string = '';
  showFooter : boolean = true;

  constructor(private srvES : ExternalSettingsService,
    protected srvAppMode: AppModeService,
    private srvUser : UserService) {
      this.loggedIn = this.srvUser.isLoggedIn$;
    }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((value) => {
      this.externalSettings = value;
      this.externalLoaded = true;
      this.disclaimerLogin = value.web.disclaimerLogin;
      this.customerMenuStyle = value.globalVariables.customerWebMenuStyle;
      if (value.systemVariables.copyrightMessage) {
        this.copyrightMessage = value.systemVariables.copyrightMessage;
      }
      this.showFooter = value.web.viewImages && value.web.viewImages.secureicon.length > 0;
    })
  }
}
